export const allSteps = [
  { key: "Draft", title: "Draft", alwaysShow: false },
  { key: "PendingApproval", title: "Pending Approval", alwaysShow: false },
  { key: "OpenForBids", title: "Open For Bids", alwaysShow: true },
  { key: "BidReceived", title: "Bid Received", alwaysShow: true },
  { key: "Confirmed", title: "Confirmed", alwaysShow: true },
  { key: "EnRouteToPickup", title: "En Route To Pickup", alwaysShow: true },
  { key: "ArrivedAtPickup", title: "Arrived At Pickup", alwaysShow: true },
  { key: "LoadingStarted", title: "Loading Started", alwaysShow: true },
  { key: "Dispatched", title: "Dispatched", alwaysShow: true },
  { key: "InTransit", title: "In Transit", alwaysShow: true },
  { key: "ArrivedAtDestination", title: "Arrived At Destination", alwaysShow: true },
  { key: "UnloadingStarted", title: "Unloading Started", alwaysShow: true },
  { key: "Delivered", title: "Delivered", alwaysShow: true },
  { key: "Completed", title: "Completed", alwaysShow: true },
  { key: "Dispute", title: "Dispute", alwaysShow: false },
  { key: "Resolved", title: "Resolved", alwaysShow: false },
  { key: "Cancelled", title: "Cancelled", alwaysShow: false }, // always at last
];